import { Injectable, signal } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: "root", })
export class NotificationsSidebarService {
  private readonly _isOpen = signal(false);

  readonly isOpen = this._isOpen.asReadonly();
  private _unreadNotificationsCount$ = new BehaviorSubject<number>(0);

  unreadNotificationsCount$ = this._unreadNotificationsCount$.asObservable();

  addNotificationsCount(count: number): void {
    this._unreadNotificationsCount$.next(this._unreadNotificationsCount$.value + count);
  }

  onDecrementCount(): void {
    const currentCount = this._unreadNotificationsCount$.value;

    this._unreadNotificationsCount$.next(currentCount > 0 ? currentCount - 1 : 0);
  }

  resetNotificationsCount(): void {
    this._unreadNotificationsCount$.next(0);
  }

  setNotificationsCount(count: number): void {
    this._unreadNotificationsCount$.next(count);
  }

  open(): void {
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  toggle(): void {
    this._isOpen.update(value => !value);
  }
}
